import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import Close from '../../../public/svg/close.svg';
import styles from './pdp-modal.module.scss';

// We have to use javascript to change the z-index of the section that
// contains the modal. This is currently its ID
const modalSectionId = 'purchaseTransition';

type Props = {
  className?: string;
  darkTheme?: boolean;
  children: any;
  isModalOpen: boolean;
  onCloseModal: () => void;
  fullscreen?: boolean;
};

const PDPModal = ({
  className,
  darkTheme,
  children,
  isModalOpen,
  onCloseModal,
  fullscreen = true
}: Props) => {
  const [isModalShowing, setIsModalShowing] = useState(false);

  const closeModal = () => {
    document.body.style.overflow = 'auto';
    const element = document.getElementById(modalSectionId);
    if (element) {
      element.style.position = 'static';
      element.style.zIndex = 'auto';
    }
    setIsModalShowing(false);
    setTimeout(onCloseModal, 300);
  };

  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  useEffect(() => {
    const handleEscPress = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isModalOpen) {
        closeModal();
      }
    };

    document.addEventListener('keydown', handleEscPress);

    return () => document.removeEventListener('keydown', handleEscPress);
  }, [isModalOpen]);

  useEffect(() => {
    if (isModalOpen) {
      setTimeout(() => setIsModalShowing(true), 100);
      if (fullscreen) {
        const element = document.getElementById(modalSectionId);
        if (element) {
          element.style.position = 'relative';
          element.style.zIndex = '15';
        }
        scrollTop();
        document.body.style.overflow = 'hidden';
      }
    } else {
      closeModal();
    }
  }, [isModalOpen, fullscreen]);

  return (
    <aside
      className={cx(
        styles['pdp-modal__container'],
        className,
        darkTheme && styles['pdp-modal__container--dark'],
        {
          [styles['pdp-modal__container--open']]: isModalOpen,
          [styles['pdp-modal__container--showing']]: isModalShowing
        }
      )}
      id="modal"
    >
      {children}
      <div className={styles['pdp-modal__close-icon-container']}>
        <button
          className={styles['pdp-modal__close-button']}
          onClick={closeModal}
          type="button"
          name="close pdp-well modal"
        >
          <Close
            className={styles['pdp-modal__close-icon']}
            alt="close modal"
          />
        </button>
      </div>
    </aside>
  );
};

export default PDPModal;
